import { render } from "./Svgi.vue?vue&type=template&id=709babf4"
import script from "./Svgi.vue?vue&type=script&lang=js"
export * from "./Svgi.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/jobs/ohm-landing/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__